import { render } from "./About.vue?vue&type=template&id=13acaccb"
const script = {}

import "./About.vue?vue&type=style&index=0&id=13acaccb&lang=css"
script.render = render

export default script